{
  "cms.previewFrame.loading": "Ladataan esikatselua…",
  "cms.previewFrame.unavailable.title": "Esikatselu ei ole käytettävissä",
  "cms.previewFrame.unavailable.body": "Tämä esikatselu on tarkoitettu vain CMS-ylläpitäjille. Kirjaudu sisään ylläpitäjänä jatkaaksesi.",
  "cms.preview.description": "Esikatselu luonnoksesta sellaisena kuin jäsenet näkevät sen.",
  "cms.preview.device.desktop": "Desktop",
  "cms.preview.device.label": "Näyttömuoto",
  "cms.preview.device.mobile": "Mobiili",
  "cms.preview.frameTitle": "Esikatselu jäsensivusta",
  "cms.preview.shapeUnavailable": "Esikatselu ei ole vielä saatavilla tälle sisältötyypille.",
  "cms.preview.title": "Esikatselu (luonnos + julkaistu)",
  "cms.preview.zoom.label": "Zoom",
  "cms.viewport.desktopRequired.body": "Sisällönhallinta vaatii työpöytäkokoluokan näytön. Jatka työaseman selaimessa.",
  "cms.viewport.desktopRequired.title": "Sisällönhallinta vaatii työpöydän"
}
